import { render, staticRenderFns } from "./YourServicesView.vue?vue&type=template&id=0fa1f90f&scoped=true&"
import script from "./YourServicesView.vue?vue&type=script&lang=ts&"
export * from "./YourServicesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1f90f",
  null
  
)

export default component.exports